export class MedicalLogs
{
    medicalLogsArr:
    {
        type: string;
        date: Date;
        height:number;
        weight:number;
        incidentName:string;
        comment:string;
    }[]
}